import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(
  {
    'btn-xyz': {
      display: 'inline-block',
      alignItems: 'center',
      textAlign: 'center',
      fontSize: '14px',
      justifyContent: 'center',
      border: '0.1em solid #fffff',
      boxSizing: 'border-box',
      textDecoration: 'none',
      font: 'Arial',
      transition: 'all 0.2s',
      cursor: 'pointer',
      userSelect: 'none',
      outline: 'none',
      '&:focus': {
        outline: 'none'
      },
      '&:hover': {
        outline: 'none'
      },
      '&:disabled': {
        outline: 'none'
      }
    },

    'btn--primary--solid': {
      backgroundColor: 'var(--primary50)',
      border: '0.1em solid white',
      opacity: 1,
      color: 'white',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 0.9,
        border: '0.1em solid var(--primary50)',
        color: 'var(--primary50)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--primary50)'
      }
    },

    'btn--primary--outline': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--primary50)',
      opacity: 1,
      color: 'var(--primary50)',
      '&:active': {
        backgroundColor: 'var(--primary50)',
        opacity: 1,
        border: '0.1em solid currentColor',
        color: 'var(--white)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--primary50)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--primary50)'
      }
    },

    'btn--primary--text': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--trasparent)',
      opacity: 1,
      color: 'var(--primary50)',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 1,
        border: '0.1em solid var(--trasparent)',
        color: 'currentColor'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--primary50)'
      }
    },

    'btn--link--solid': {
      backgroundColor: 'var(--link50)',
      border: '0.1em solid white',
      opacity: 1,
      color: 'white',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 0.9,
        border: '0.1em solid var(--link50)',
        color: 'var(--link50)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--link50)'
      }
    },

    'btn--link--outline': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--link50)',
      opacity: 1,
      color: 'var(--link50)',
      '&:active': {
        backgroundColor: 'var(--link50)',
        opacity: 1,
        border: '0.1em solid currentColor',
        color: 'var(--white)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--link50)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--link50)'
      }
    },

    'btn--link--text': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--trasparent)',
      opacity: 1,
      color: 'var(--link50)',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 1,
        border: '0.1em solid var(--trasparent)',
        color: 'currentColor'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--link50)'
      }
    },

    'btn--red--solid': {
      backgroundColor: 'var(--red50)',
      border: '0.1em solid white',
      opacity: 1,
      color: 'white',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 0.9,
        border: '0.1em solid var(--red50)',
        color: 'var(--red50)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--red50)'
      }
    },

    'btn--red--outline': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--red50)',
      opacity: 1,
      color: 'var(--red50)',
      '&:active': {
        backgroundColor: 'var(--red50)',
        opacity: 1,
        border: '0.1em solid currentColor',
        color: 'var(--white)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--red50)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--red50)'
      }
    },

    'btn--red--text': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--trasparent)',
      opacity: 1,
      color: 'var(--red50)',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 1,
        border: '0.1em solid var(--trasparent)',
        color: 'currentColor'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--red50)'
      }
    },

    'btn--secondary--solid': {
      backgroundColor: 'var(--secondary50)',
      border: '0.1em solid white',
      opacity: 1,
      color: 'white',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 0.9,
        border: '0.1em solid var(--secondary50)',
        color: 'var(--secondary50)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--secondary50)'
      }
    },

    'btn--secondary--outline': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--secondary50)',
      opacity: 1,
      color: 'var(--secondary50)',
      '&:active': {
        backgroundColor: 'var(--secondary50)',
        opacity: 1,
        border: '0.1em solid currentColor',
        color: 'var(--white)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--secondary50)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--secondary50)'
      }
    },

    'btn--secondary--text': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--trasparent)',
      opacity: 1,
      color: 'var(--secondary50)',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 1,
        border: '0.1em solid var(--trasparent)',
        color: 'currentColor'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--secondary50)'
      }
    },

    'btn--success--solid': {
      backgroundColor: 'var(--success50)',
      border: '0.1em solid white',
      opacity: 1,
      color: 'white',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 0.9,
        border: '0.1em solid var(--success50)',
        color: 'var(--success50)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--success50)'
      }
    },

    'btn--success--outline': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--success50)',
      opacity: 1,
      color: 'var(--success50)',
      '&:active': {
        backgroundColor: 'var(--success50)',
        opacity: 1,
        border: '0.1em solid currentColor',
        color: 'var(--white)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--success50)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--success50)'
      }
    },

    'btn--success--text': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--trasparent)',
      opacity: 1,
      color: 'var(--success50)',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 1,
        border: '0.1em solid var(--trasparent)',
        color: 'currentColor'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--success50)'
      }
    },

    'btn--danger--solid': {
      backgroundColor: 'var(--danger50)',
      border: '0.1em solid white',
      opacity: 1,
      color: 'white',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 0.9,
        border: '0.1em solid var(--danger50)',
        color: 'var(--danger50)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--danger50)'
      }
    },

    'btn--danger--outline': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--danger50)',
      opacity: 1,
      color: 'var(--danger50)',
      '&:active': {
        backgroundColor: 'var(--danger50)',
        opacity: 1,
        border: '0.1em solid currentColor',
        color: 'var(--white)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--danger50)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--danger50)'
      }
    },

    'btn--danger--text': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--trasparent)',
      opacity: 1,
      color: 'var(--danger50)',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 1,
        border: '0.1em solid var(--trasparent)',
        color: 'currentColor'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--danger50)'
      }
    },

    'btn--dark--solid': {
      backgroundColor: 'var(--dark60)',
      border: '0.1em solid white',
      opacity: 1,
      color: 'white',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 0.9,
        border: '0.1em solid var(--dark60)',
        color: 'var(--dark60)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--dark60)'
      }
    },

    'btn--dark--outline': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--dark60)',
      opacity: 1,
      color: 'var(--dark60)',
      '&:active': {
        backgroundColor: 'var(--dark60)',
        opacity: 1,
        border: '0.1em solid currentColor',
        color: 'var(--white)'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--dark60)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--dark60)'
      }
    },

    'btn--dark--text': {
      backgroundColor: 'var(--trasparent)',
      border: '0.1em solid var(--trasparent)',
      opacity: 1,
      color: 'var(--dark60)',
      '&:active': {
        backgroundColor: 'var(--trasparent)',
        opacity: 1,
        border: '0.1em solid var(--trasparent)',
        color: 'currentColor'
      },
      '&:hover': {
        opacity: '0.7',
        transition: 'none'
      },
      '&:disabled': {
        border: '0.1em solid var(--trasparent)',
        backgroundColor: 'var(--trasparent)',
        color: 'var(--dark60)'
      }
    },

    'btn--round': {
      borderRadius: '1.12em'
    },
    'btn--square': {
      borderRadius: '0.22em'
    },
    'btn--xs': {
      padding: '0 0.6rem',
      margin: '0.6em'
    },
    'btn--sm': {
      padding: '0.2em 1.6em',
      margin: '0.6em',
      fontSize: '15px'
    },
    'btn--md': {
      padding: '0.3em 2em',
      margin: '0.6em',
      fontSize: '16px'
    },
    'btn--lg': {
      padding: '0.4em 2.4em',
      margin: '0.6em',
      fontSize: '17px'
    },
    'btn--xl': {
      padding: '0.5em 2.8em',
      margin: '0.6em',
      fontSize: '18px'
    },
    'icon--md': {
      fontSize: '16px'
    },
    fullWidth: {
      width: '100%'
    },
    disabled: {
      opacity: '0.4',
      textDecoration: 'none',
      pointerEvents: 'none'
    },
    'icon--btn': {
      padding: '0 18px 0 0',
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      '& > span': {
        display: 'flex'
      }
    },
    'start--icon': {
      '& > *': {
        paddingRight: '18px'
      }
    },
    label: {
      width: '100%',
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  },
  { name: 'bund-' }
)

const VARIANTS = ['solid', 'outline', 'text', 'contained']
const COLORS = [
  'primary',
  'secondary',
  'link',
  'success',
  'danger',
  // 'warning',
  // 'info',
  // 'light',
  'dark',
  'red'
]
const SIZES = ['xs', 'sm', 'md', 'lg', 'xl']

export const Button = (props) => {
  const {
    children,
    title,
    type,
    onClick,
    component = 'button' | 'a' | 'div',
    endIcon,
    startIcon,
    className,
    style,
    disabled = false,
    href,
    fullWidth = false,
    shape = 'round',
    variant = VARIANTS[0],
    color = COLORS[0],
    size = SIZES[2],
    ...rest
  } = props
  const classes = useStyles()

  return href || component === 'a' ? (
    <a
      className={clsx(
        startIcon || endIcon
          ? classes['icon--btn'] + ' bund--icon--btn'
          : classes['btn-xyz'],
        classes[`btn--${color}--${variant}`],
        classes[`btn--${shape}`],
        classes[`btn--${size}`],
        fullWidth && classes.fullWidth,
        disabled && classes.disabled,
        className
      )}
      href={href}
      style={style}
      disabled={disabled}
      {...rest}>
      <span className={classes.label}>
        {startIcon && (
          <span
            className={clsx(classes['start--icon'], classes[`icon--${size}`])}>
            {startIcon}
          </span>
        )}
        {children}
        {endIcon && (
          <span
            className={clsx(classes['end--icon'], classes[`icon--${size}`])}>
            {endIcon}
          </span>
        )}
      </span>
    </a>
  ) : (
    <button
      title={title}
      className={clsx(
        startIcon || endIcon
          ? classes['icon--btn'] + ' bund--icon--btn'
          : classes['btn-xyz'],
        classes[`btn--${color}--${variant}`],
        classes[`btn--${shape}`],
        classes[`btn--${size}`],
        fullWidth && classes.fullWidth,
        disabled && classes.disabled,
        className
      )}
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={style}
      {...rest}>
      <span className={classes.label}>
        {startIcon && (
          <span
            className={clsx(classes['start--icon'], classes[`icon--${size}`])}>
            {startIcon}
          </span>
        )}
        {children}
        {endIcon && (
          <span
            className={clsx(classes['end--icon'], classes[`icon--${size}`])}>
            {endIcon}
          </span>
        )}
      </span>
    </button>
  )
}

Button.propTypes = {
  /**
   * The content of the button.
   */
  children: PropTypes.node.isRequired,

  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,

  /**
   * @ignore
   */

  endIcon: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  title: PropTypes.string,

  type: PropTypes.oneOfType([
    PropTypes.oneOf(['button', 'reset', 'submit']),
    PropTypes.string
  ]),

  onClick: PropTypes.func,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'danger',
    // 'warning',
    // 'info',
    // 'light',
    'dark',
    'red',
    'link'
  ]),

  /**
   * The shape of the component.
   */
  shape: PropTypes.oneOf(['round', 'square']),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['text', 'contained', 'solid', 'outline']),

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string
}

Button.defaultProps = {
  variant: 'solid',
  color: 'primary',
  size: 'md',
  shape: 'round'
}

Button.displayName = 'b'

export default Button
